import React from 'react';
import styles from './footer.module.css';

import { menus } from '../../data/menu';
import { Link } from 'react-router-dom';

const Footer = ({ isSimple }) => {
  const logoImgSrc = `${process.env.PUBLIC_URL}/imgs/${
    isSimple ? 'UNOS' : 'UNOS_white'
  }.png`;

  return (
    <footer className={`${styles.footer} ${isSimple ? styles.simple : ''}`}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <img src={logoImgSrc} alt='UNOSPAY' />
          </div>

          {isSimple ? null : (
            <div className={styles.menuContainer}>
              {menus.map((menu) => {
                const { title, children, url } = menu;
                return (
                  <div className={styles.menu} key={title}>
                    <span
                      className={`${styles.title} ${
                        !children && styles.textBlue
                      }`}
                    >
                      {title}
                    </span>
                    <ul className={styles.subContainer} key={menu.title}>
                      {children &&
                        children.map((subMenu, index) => {
                          return (
                            <li key={index}>
                              <Link to={`${url}/${subMenu.url}`}>
                                {subMenu.title}
                              </Link>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <div className={styles.infoContainer}>
        <div className={styles.infoBox}>
          <div className={styles.info}>
            <span>회사명</span>
            (주)우노스
          </div>
          <div className={styles.info}>
            <span>대표이사</span>
            송영우
          </div>
          <div className={styles.info}>
            <span>사업자등록번호</span>
            138-86-01778
          </div>
          <div className={styles.info}>
            <span>TEL</span>
            1800-4520
          </div>
          <div className={styles.info}>
            <span>FAX</span>
            02-6919-9019
          </div>
          <div className={[styles.info, styles.address].join(' ')}>
            <span>주소</span>
            서울특별시 강남구 도산대로6길 12, 2층 <br />
            경기도 안양시 동안구 시민대로109번길 29, 216~219호
          </div>
        </div>

        {isSimple ? null : (
          <div className={styles.snsBox}>
            <a
              className={styles.sns}
              href='https://www.instagram.com/unospay/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src={process.env.PUBLIC_URL + '/imgs/etc/insta.png'}
                alt='insta'
              />
            </a>
            <a
              className={styles.sns}
              href='https://blog.naver.com/unos0223'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src={process.env.PUBLIC_URL + '/imgs/etc/blog.png'}
                alt='blog'
              />
            </a>
            {/* <a
              className={styles.sns}
              href='https://pf.kakao.com/_xeAZsd'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src={process.env.PUBLIC_URL + '/imgs/etc/kakao.png'}
                alt='kakao'
              />
            </a> */}
          </div>
        )}

        <div className={styles.policyBox}>
          <Link to={'/privacy'}>개인정보처리방침</Link>
          <Link to={'/email'}>무단이메일수집거부</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
